import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { catchError } from 'rxjs'

import { ErrorService } from '../services/error.service'

export const DISABLE_GLOBAL_EXCEPTION_HANDLING = new HttpContextToken<boolean>(
  () => false
)

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(DISABLE_GLOBAL_EXCEPTION_HANDLING)) {
    return next(req)
  }

  const errorService = inject(ErrorService, {})

  return next(req).pipe(
    catchError((err) => {
      errorService.setError(err)
      throw err
    })
  )
}
